import { render } from "./reference-search-panel.vue?vue&type=template&id=395a5b3a&scoped=true"
import script from "./reference-search-panel.vue?vue&type=script&lang=js"
export * from "./reference-search-panel.vue?vue&type=script&lang=js"

import "./reference-search-panel.vue?vue&type=style&index=0&id=395a5b3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395a5b3a"]])

export default __exports__